interface NeoSubHeaderProps {
  message: string;
}

export const NeoSubHeader: React.FC<NeoSubHeaderProps> = ({message}) => {
  return <h5 className="text-xl">{message}</h5>;
};
